package com.patronat.top.client.platform

import androidx.compose.runtime.Composable

@Composable
actual fun ClientBackHandler(
    enabled: Boolean,
    onBack: () -> Unit
) {
}
